import request from '@/utils/request'

// 分页查询水电收支信息
export function getPageList(params) {
  return request({
    url: '/hrApi/otherFee',
    method: 'get',
    params: params
  })
}

// 获取水电收支列表
export function getList(params) {
  return request({
    url: '/hrApi/otherFee/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑水电收支
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/otherFee',
    method: 'post',
    data: data
  })
}

// 删除水电收支
export function deleteData(id) {
  return request({
    url: '/hrApi/otherFee/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/otherFee.js